<template>
  <MainLayout>
    <v-container class="mt-10">
      <v-row>
        <v-breadcrumbs :items="breadcrumbs">
            <template v-slot:prepend>
              <v-icon icon="$vuetify" size="small"></v-icon>
            </template>
          </v-breadcrumbs>
        <v-col>
           <v-btn @click="showAddUserDialog" color="primary float-right"
            >Kullanıcı Ekle</v-btn
          >
          <!-- Kullanıcı Ekle Butonu -->
        </v-col>
      </v-row>

      <v-dialog v-model="addUserDialog" max-width="600px">
        <v-card>
          <v-card-title>
            <span class="headline">Kullanıcı Ekle</span>
          </v-card-title>
          <v-card-text>
            <v-form ref="form" v-model="valid">
              <v-text-field
                v-model="newUser.name"
                label="Ad"
                :rules="[rules.required]"
                required
              ></v-text-field>
              <v-text-field
                v-model="newUser.email"
                label="Email"
                :rules="[rules.required, rules.email]"
                required
              ></v-text-field>
    
              <SellerSelect v-model="newUser.seller_id" :rules="[rules.required]" />
              <v-select
                v-model="newUser.status"
                :item-props="statusProps"
                :items="statusItems"
                label="Durum"
                :rules="[rules.required]"
                required
              ></v-select>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="addUser">Ekle</v-btn>
            <v-btn color="grey" text @click="addUserDialog = false"
              >İptal</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-row>
        <v-col>
          <v-data-table
            :headers="headers"
            :items="userList"
            :items-per-page="50"
            class="elevation-1"
            :loading="loading"
            :search="search"
          >
            <template v-slot:top>
              <v-toolbar flat>
                <v-toolbar-title>Kullanıcı Listesi</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-text-field
                  v-model="search"
                  label="Ara..."
                  class="mx-4"
                  solo
                  clearable
                ></v-text-field>
              </v-toolbar>
            </template>

            <template v-slot:item="{ item }">
              <tr>
                <td>{{ item.name }}</td>
                <td>{{ item.email }}</td>
                <td>{{ item.seller ? item.seller.name : "" }}</td>
                <td>
                  <v-switch
                    :model-value="item.status === true"
                    color="primary"
                    :label="item.status === true ? 'Aktif' : 'Pasif'"
                    @input="() => statusChange(item)"
                  ></v-switch>
                </td>
                <td class="text-end">
                  <!--v-btn
                    size="30"
                    @click="deleteUser(item.id)"
                    color="orange"
                    class="icon-size"
                    icon
                  >
                    <v-icon color="white" size="20">mdi-delete</v-icon>
            
                  </v-btn -->
                  <v-btn
                    size="30"
                    @click="editUser(item.id)"
                    color="orange"
                    class="icon-size ml-3"
                    icon
                  >
                    <v-icon color="white" size="20">mdi-pencil</v-icon>
                    <!-- Silme ikonu -->
                  </v-btn>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-container>
  </MainLayout>
</template>

<script>
import { mapState } from "vuex";

import authService from "@/services/authService";
import MainLayout from "@/layouts/MainLayout.vue";
import Swal from "sweetalert2"; // SweetAlert2'yi içe aktar
import SellerSelect from "@/components/SellerSelect.vue";

export default {
  name: "UserList",
  components: {
    MainLayout,SellerSelect
  },
  created() {
    this.fetchUserList();
  },
  data() {
    return {
        breadcrumbs: [
        {
          title: "Anasayfa",
          disabled: false,
          href: "pDashboard",
        },
        {
          title: "Kullanıcılar",
          disabled: false,
          href: "",
        },
      ],
      headers: [
        { text: "Adı Soyadı", value: "name" },
        { text: "Email", value: "email" },
        { text: "Şube", value: "seller.name" },
        { text: "Durum", value: "status" },
        { text: "İşlemler", value: "actions", sortable: false }, // Aksiyonlar için
      ],
      select: { name: "Seçiniz", id: "0" },
      userList: [], // Kullanıcı listesi
       loading: false, // Yükleniyor durumu
      search: "", // Arama metni
      addUserDialog: false, // Kullanıcı ekleme modal durumu
      newUser: {
        // Yeni kullanıcı bilgileri
        name: "",
        email: "",
        phone: "",
        status: null,
        seller_id: null, // Seller ID
      },
      valid: false, // Form geçerliliği
      rules: {
        required: (value) => !!value || "Bu alan gereklidir.",
        email: (value) =>
          /.+@.+\..+/.test(value) || "Geçerli bir email adresi girin.",
      },
      statusItems: [
        { text: "Aktif", value: 1 },
        { text: "Pasif", value: 0 },
      ],
    };
  },

  computed: {
    ...mapState(["user"]), // Vuex state'inden user'ı al
  },
  methods: {
    statusChange(item) {
      // Kullanıcının durumunu güncellemek için API çağrısı yapın
      const newStatus = item.status === true ? false : true; // Durumu değiştir
      // API çağrısını burada yapın
      authService
        .updateUserStatus(item.id, newStatus)
        .then((response) => {
          if (response) {
            this.fetchUserList();
            item.status = newStatus;
            Swal.fire('Kullanıcı Güncellendi');
          }
        })
        .catch((error) => {
          console.error("Durum güncellenirken hata oluştu:", error);
        });
    },

    showAddUserDialog() {
      this.resetNewUser(); // Formu sıfırla
      this.addUserDialog = true; // Modalı göster
    },
    statusProps(statusItems) {
      return {
        title: statusItems.text,
        value: statusItems.value,
      };
    },

    fetchUserList() {
      this.loading = true; // Yükleniyor durumunu başlat
      authService
        .userList()
        .then((response) => {
          console.log(response);
          this.userList = response; // Kullanıcı listesini güncelle
        })
        .catch((error) => {
          console.error("Bir hata oluştu:", error);
        })
        .finally(() => {
          this.loading = false; // Yükleniyor durumunu bitir
        });
    },

 
    sellerProps(sellerList) {
      return {
        title: sellerList.name,
        value: sellerList.id,
      };
    },
    async addUser() {
      if (this.$refs.form.validate()) {
        // Formu doğrula
        try {
          await authService.addUser(this.newUser); // Yeni kullanıcıyı ekle
          this.fetchUserList(); // Kullanıcı listesini güncelle
          this.addUserDialog = false; // Modalı kapat
          this.resetNewUser(); // Yeni kullanıcı formunu sıfırla
        } catch (error) {
          console.error("Kullanıcı eklenirken hata oluştu:", error);
        }
      }
    },

    async editUser(userId) {
      // Kullanıcı bilgilerini al
      const userToEdit = this.userList.find((user) => user.id === userId);
      if (userToEdit) {
        this.newUser = {
          ...userToEdit,
        }; // Kullanıcı bilgilerini form alanlarına doldur
        this.addUserDialog = true; // Modalı aç
      }
    },

    async deleteUser(userId) {
      const { value: confirmDelete } = await Swal.fire({
        title: "Silmek istediğinize emin misiniz?",
        text: "Bu işlem geri alınamaz!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Evet, sil!",
        cancelButtonText: "Hayır, iptal et!",
      });

      if (confirmDelete) {
        try {
          await authService.deleteUser(userId); // Kullanıcıyı silmek için servisi çağır
          this.fetchUserList(); // Kullanıcı listesini güncelle
          Swal.fire("Silindi!", "Kullanıcı başarıyla silindi.", "success");
        } catch (error) {
          console.error("Kullanıcı silinirken hata oluştu:", error);
          Swal.fire("Hata!", "Kullanıcı silinirken bir hata oluştu.", "error");
        }
      } else {
        Swal.fire(
          "İptal edildi",
          "Kullanıcı silme işlemi iptal edildi.",
          "info"
        );
      }
    },
    resetNewUser() {
      this.newUser = {
        name: "",
        email: "",
        phone: "",
        status: null,
        seller_id: null, // Seller ID
      }; // Yeni kullanıcıyı sıfırla
    },
  },
};
</script>

<style scoped>
/* İsteğe bağlı stil ayarları */
.v-data-table {
  background-color: #ffffff;
  /* Beyaz arka plan */
  border-radius: 8px;
  /* Köşeleri yuvarla */
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  /* Hafif gölge */
}

.icon-size {
  width: 30px;
  height: 30px;
}
</style>
